module.exports = __webpack_public_path__ + "static/media/Home.649e6944.svg";


//////////////////
// WEBPACK FOOTER
// ./src/artist-ui/components/Image/Home.svg
// module id = 187
// module chunks = 0